import {inject, injectable} from "inversify";
import {EventSubscriber, HasEventName} from "@/modules/base/events";
import {Notifier} from "@/modules/notifications/services/Notifier";
import {AfterTransferOfferCreateEvent} from "@/modules/transfer-market/events/AfterTransferOfferCreateEvent";
import {TransferOfferNotification} from "@/modules/transfer-market/entity/TransferOfferNotification";
import {AfterTransferEvent} from "@/modules/transfer-market/events/AfterTransferEvent";
import {TransferNotification, TransferOfferAbortNotification} from "@/modules/transfer-market/entity";
import {AfterTransferOfferAbortedEvent} from "@/modules/transfer-market/events/AfterTransferOfferAbortedEvent";

@injectable()
export default class NotificationEventSubscriber implements EventSubscriber {
  constructor(
    @inject(Notifier) private notifier: Notifier,
  ) {
  }

  priority(): number {
    return 0;
  }

  init(): { event: HasEventName; callback: (event: any) => void }[] {
    return [
      {event: AfterTransferOfferCreateEvent, callback: this.onAfterTransferOfferCreateEvent},
      {event: AfterTransferEvent, callback: this.onAfterTransferEvent},
      {event: AfterTransferOfferAbortedEvent, callback: this.onAfterTransferOfferAbortedEvent},
    ];
  }

  public async onAfterTransferOfferAbortedEvent(event: AfterTransferOfferAbortedEvent) {
    if (!event.offer.team || !event.offer.team.user) {
      return;
    }

    await this.notifier.notify(new TransferOfferAbortNotification().setPayload(event.player));
  }

  public async onAfterTransferOfferCreateEvent(event: AfterTransferOfferCreateEvent) {
    if (!event.player.team || !event.player.team.user) {
      return;
    }

    const notification = new TransferOfferNotification().setPayload(event.player);

    await this.notifier.notify(notification);
  }

  public async onAfterTransferEvent(event: AfterTransferEvent) {
    if (!event.player.team || !event.player.team.user) {
      return;
    }

    const notification = new TransferNotification().setPayload(
      event.player,
      event.price,
      event.team.user ? 'in' : 'out'
    );

    await this.notifier.notify(notification);
  }
}
